/**
 * /frontend/src/features/analytics/components/abandonment/AbandonmentKPIs.js
 */

import React from 'react';
import KPICardRow from '../shared/KPICardRow';
import KPICard from '../shared/KPICard';
import { formatCurrencyInr, formatMinutes } from '../../utils/formatters';

/**
 * Abandonment KPI cards.
 * @param {{summary:any}} props
 * @returns {JSX.Element}
 */
const AbandonmentKPIs = ({ summary }) => (
  <KPICardRow>
    <KPICard label="Total abandonments" value={Number(summary?.totalAbandoned || 0).toLocaleString('en-IN')} />
    <KPICard label="Revenue loss" value={formatCurrencyInr(summary?.estimatedRevenueLoss)} />
    <KPICard label="Avg wait before abandon" value={formatMinutes(summary?.avgMinutesBeforeAbandonment)} />
    <KPICard label="Tolerance threshold" value={formatMinutes(summary?.waitToleranceThresholdMinutes)} />
  </KPICardRow>
);

export default AbandonmentKPIs;

